const projects = {
  project0: {
    name: "Valken Sports",
    image: "/images/Valken-Homepage.png",
    desc:
      "Shop Valken, the leading manufacturer and supplier of Paintball, Airsoft, and Defense Protection gear and equipment. This website was created through a Workarea CMS, built on Ruby on Rails. I managed all aspects of website, inventory, and design. Assisted third party development team from conception, and in initial design, functionality, and layout. Additionally, I managed 4 other Valken websites, including Canadian, European, and Dealer platforms.",
    retailWebsite: "https://www.valken.com/",
    dealerWebsite: "https://www.valkendealer.com/",
  },
  project1: {
    name: "Paintball Uncensored",
    image: "/images/PBU.png",
    desc: `This desktop and mobile application was built to provide a community to talk paintball, connect with fellow paintball players, find paintball fields, search paintball events, get access to top brands, keep up with the latest news, topics & trends, buy sell & trade paintball gear. This mobile app utilizes a third-party platform (Disciple Media) to host application, as well as provide skeletal framework to build on. I managed all aspects of this application, and at the time of my departure, we had over 1000+ members signed in and active on a daily basis.`,
    apple: "https://apps.apple.com/us/app/paintball-uncensored/id1572831848",
    google: "https://play.google.com/store/apps/details?id=uk.co.disciplemedia.paintball",
  },
  project2: {
    name: "NJB Painting Inc.",
    image: "/images/NJBpainting.png",
    desc:
      "Developed a company website for NJB Painting Inc. as a freelance project, to help with their web presence and SEO optimization. This website is a MERN stack website, utilizing Mailgun/Nodemailer for form submission.",
    githubURL: "https://github.com/jsmithxyz/njb-painting-website",
    website: "https://www.njbpainting.com",
  },
  project3: {
    name: "MAJJ",
    image: "/images/login.gif",
    desc: `MAJJ is a web application that serves the user fresh content from thousands of providers, presenting the ability to conveniently view and save articles for your reading pleasure. In the event that you’re unable to view content in the moment or find content but want to save it for later use, MAJJ allows you to create your own profile, filter through content based on your interests and save this content and your interests all in a single location for you to re-visit whenever you please.`,
    githubURL: "https://github.com/jsmithxyz/majj",
    website: "https://www.majj.app/",
  },
  project4: {
    name: "Godzilla Quiz",
    image: "/images/GodzillaQuizPhoto.png",
    desc:
      "This application will run the user through a Godzilla themed quiz. The user will then be able to track their scores in the same session, and see these scores at any time. Scores are based off of how many seconds are remaining when all of the questions are answered. Simple application built on CSS, HTML, and JS.",
    githubURL: "https://github.com/jsmithxyz/godzilla-quiz",
    website: "https://jsmithxyz.github.io/godzilla-quiz/quiz.html",
  },
  project5: {
    name: "Philly Auto Emporium",
    image: "/images/PhillyCarEmporium.png",
    desc: `This application allows a Used Car Dealership to keep track and manage it's inventory, as well as display it for potential buyers. This web app utilizes a third-party API (CarMD) to collect accurate car data, AJAX calls to get/post/delete data, Node for back-end, Express for routing, NodeMailer for sending emails, and MySQL for saving/deleting car data for inventory purposes. The front-end design was built with HTML, CSS, and Foundation framework.`,
    githubURL: "https://github.com/jsmithxyz/philly-car-emporium",
    website: "https://philly-car-emporium.herokuapp.com/",
  },
  project6: {
    name: "Eat-Da-Burger",
    image: "/images/BurgerApp.png",
    desc:
      "This application is designed to provide the user the ability of adding and keeping track of the different types of burgers they desire and have devoured. This is a burger logger application built with MySQL, Node, Express, Handlebars and a homemade ORM.",
    githubURL: "https://github.com/jsmithxyz/Eat-Da-Burger",
    website: "https://jsmithxyz-burger.herokuapp.com/",
  },
};

export default projects;
